<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
        <b-card :header="$t('Add Manual Report')" style="position:relative">
          <b-form autocomplete="off" ref="aud">
            <b-row>
              <b-col cols="12" md="6">
                <div class="mb-2 position-relative">
                  <div class="multiselect-lbl" v-if="details.company_id">{{$t('Shops')}}</div>
                  <multiselect
                    v-model="details.shop_id"
                    :options="shopList"
                    placeholder="Select a shop"
                    track-by="eid"
                    label="name"
                    :translate="false"
                  ></multiselect>
                </div>
              </b-col>
              <b-col cols="12" md="6">
                <div class="mb-2 position-relative">
                  <div class="multiselect-lbl" v-if="details.company_id">{{$t('Products')}}</div>
                  <multiselect
                    v-model="details.product_id"
                    :options="productList"
                    placeholder="Select a product"
                    track-by="eid"
                    label="name"
                    :translate="false"
                  ></multiselect>
                </div>
              </b-col>
              <!--b-col cols="12" md="4">
                <b-form-group class="mb-3" style="display:inline-block">
                  <date-range-picker
                    :startDate="timestamp"
                    :endDate="timestamp"
                    @update="updateTimestamp"
                    :locale-data="locale"
                    opens="right"
                    :timePicker="true"
                    :timePicker24Hour="true"
                    :timePickerIncrement="1"
                    :timePickerSeconds="true"
                    :ranges="false"
                    :singleDatePicker="true"
                    :label="$t('Timestamp')"
                  />
                </b-form-group>
                <b-button
                  class="ml-3"
                  type="button"
                  size="sm"
                  variant="primary"
                  @click.prevent="resetTimestamp"
                >{{$t('Reset')}}</b-button>
              </b-col-->
            </b-row>

            <b-row>
              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="details.ticket_paid_in_number"
                  label="Ticket Paid In Number"
                  type="text"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="details.payment"
                  label="Gross Payment"
                  type="text"
                  size="sm"
                />
              </b-col>

              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="details.payment_tax"
                  label="Payment Tax"
                  type="text"
                  size="sm"
                />
              </b-col>
            </b-row>
            <!--
            <b-row>
              <b-col cols="12" md="4">
                <FloatingLabel v-model.number="details.winnings" label="Winnings" type="text" size="sm" />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="details.unclaimed_winnings"
                  label="Unclaimed Winnings"
                  type="text"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="details.expired_winnings"
                  label="Expired Winnings"
                  type="text"
                  size="sm"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="details.paid_out_winnings"
                  label="Paid Out Winnings"
                  type="text"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="details.cancelled_amount"
                  label="Cancelled Amount"
                  type="text"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="details.cancelled_tax"
                  label="Cancelled Tax"
                  type="text"
                  size="sm"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="4">
                <FloatingLabel v-model.number="details.hold" label="Hold" type="text" size="sm" />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="details.bonus_payout"
                  label="Bonus Payout"
                  type="text"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="details.bonus_payout_tax"
                  label="Bonus Payout Tax"
                  type="text"
                  size="sm"
                />
              </b-col>
            </b-row>
            -->
            <!--
            <b-row>

              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="details.ticket_balance_amount"
                  label="Ticket Balance Amount"
                  type="text"
                  size="sm"
                />
              </b-col>


              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="details.ticket_paid_in_number"
                  label="Ticket Paid In Number"
                  type="text"
                  size="sm"
                />
              </b-col>


              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="details.ticket_won_number"
                  label="Ticket Won Number"
                  type="text"
                  size="sm"
                />
              </b-col>

            </b-row>-->

            <!--
            <b-row>
              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="details.ticket_paid_out_number"
                  label="Ticket Paid Out Number"
                  type="text"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="details.ticket_bonus_paid_out_number"
                  label="Ticket Bonus Paid Out Number"
                  type="text"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="details.ticket_cancelled_number"
                  label="Ticket Cancelled Number"
                  type="text"
                  size="sm"
                />
              </b-col>
            </b-row>

            <FloatingLabel
                  v-model.number="details.ticket_expired_winnings_number"
                  label="Ticket Expired Winnings Number"
                  type="text"
                  size="sm"
                />
            -->
            <b-row>
              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="details.ticket_paid_out_number"
                  label="Ticket Paid Out Number"
                  type="text"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="details.payout"
                  label="Net Payout"
                  type="text"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="details.payout_tax"
                  label="Payout Tax"
                  type="text"
                  size="sm"
                />
              </b-col>
            </b-row>
            <div style="text-align:right">
              <b-button type="button" variant="success" @click.prevent="save">{{$t('Save')}}</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
import { errorConf, successConf } from "@/shared/notifications";
import FloatingLabel from "@/components/FloatingLabel";
import Multiselect from "@/components/multiselect-filters";
import DateRangePicker from "@/components/calendar-range/DateRangePicker";
import timeFormat from "@/shared/timeFormat";

export default {
  name: "manualReport",
  components: {
    FloatingLabel,
    Multiselect,
    DateRangePicker
  },
  mounted() {
    Promise.all([
      this.$store.dispatch("cache/fetch", "shops").catch(e => e),
      this.$store.dispatch("cache/fetch", "products").catch(e => e)
    ]).finally(() => {
      console.log("loaded data");
    });
  },
  computed: {
    shopList() {
      return this.$store.getters["cache/shops"];
    },
    productList() {
      return this.$store.getters["cache/products"];
    }
  },
  data: function() {
    return {
      eid: "",
      timestamp: moment(),
      details: {
        product_id: "",
        shop_id: "",
        date_from: "",
        date_to: "",
        timestamp: moment().format("YYYY-MM-DD HH:mm:ss"),
        stake: 0,
        payment: 0,
        payment_tax: 0,
        winnings: 0,
        unclaimed_winnings: 0,
        expired_winnings: 0,
        expired_winnings_tax: 0,
        paid_out_winnings: 0,
        cancelled_amount: 0,
        cancelled_tax: 0,
        hold: 0,
        bonus_payout: 0,
        bonus_payout_tax: 0,
        ticket_balance_amount: 0,
        ticket_paid_in_number: 0,
        ticket_won_number: 0,
        ticket_paid_out_number: 0,
        ticket_bonus_paid_out_number: 0,
        ticket_cancelled_number: 0,
        ticket_expired_winnings_number: 0,
        payout_tax: 0,
        payout: 0
      },
      locale: {
        format: timeFormat.datePickerLong, //format of the dates displayed
        firstDay: 1, //ISO first day of week - see moment documenations for details
        showWeekNumbers: true //show week numbers on each row of the calendar
      }
    };
  },
  methods: {
    resetTimestamp() {
      this.timestamp = moment();
      this.details.timestamp = this.timestamp.format("YYYY-MM-DD HH:mm:ss");
    },
    updateTimestamp(value) {
      console.log("updateTimestamp", value);
      this.details.timestamp = moment(value.startDate).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    },
    save() {
      const loadDet = this.$loading.open({
        container: this.$refs.aud
      });

      const postData = JSON.parse(JSON.stringify(this.details));
      if (postData.shop_id) {
        postData.eshop_id = postData.shop_id.eid;
      }
      delete postData.shop_id;
      if (postData.product_id) {
        postData.eproduct_id = postData.product_id.eid;
      }
      delete postData.product_id;
      postData.timestamp = moment().format("YYYY-MM-DD HH:mm:ss");

      this.$store
        .dispatch("manualReport/save", postData)
        .then(resp => {
          //this.resetTimestamp();
          this.details.shop_id = null;
          this.details.product_id = null;
          this.details.payout_tax = 0;
          this.details.payout = 0;
          this.details.ticket_paid_out_number = 0;
          this.details.payment = 0;
          this.details.payment_tax = 0;
          this.details.stake = 0;
          this.details.ticket_paid_in_number = 0;
          this.showSuccessNotification("Manual report saved");
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    },
    roundThousands(value) {
      if (typeof value == "string") return value;
      if (!value) return "0.00";

      const decimals = 2;
      const tmp = value / 10000;

      return Number(Math.round(tmp + "e" + decimals) + "e-" + decimals).toFixed(
        decimals
      );
    },
    mom_unix(val) {
      return moment.unix(val / 1e9);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
